import type { CitationContentProps } from './CitationContent.types';

import './_citation-content.scss';

export const CitationContent = ({ document, onClick }: CitationContentProps) => {
  const citationIds = document.citation_ids;

  return (
    <>
      {citationIds?.map((citation, index) => (
        <div
          key={`${citation.citation_id}-${index}`}
          onClick={() => onClick?.(citation.citation_id)}
        >
          <span className="citation-content">{citation.citation_id}</span>
          <span>{index < citationIds?.length - 1 && ', '}</span>
        </div>
      ))}
    </>
  );
};
